import { render, staticRenderFns } from "./MintegralIcon.vue?vue&type=template&id=52834db8&"
import script from "./MintegralIcon.vue?vue&type=script&lang=js&"
export * from "./MintegralIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports